function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "transparent"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3332 0.833008H3.33317C2.4165 0.833008 1.6665 1.58301 1.6665 2.49967V14.1663H3.33317V2.49967H13.3332V0.833008ZM15.8332 4.16634H6.6665C5.74984 4.16634 4.99984 4.91634 4.99984 5.83301V17.4997C4.99984 18.4163 5.74984 19.1663 6.6665 19.1663H15.8332C16.7498 19.1663 17.4998 18.4163 17.4998 17.4997V5.83301C17.4998 4.91634 16.7498 4.16634 15.8332 4.16634ZM15.8332 17.4997H6.6665V5.83301H15.8332V17.4997Z",
  fill: "#fdb71a"
});

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.23802471.svg";
export { ForwardRef as ReactComponent };